import React from "react"
import PropTypes from "prop-types"
import FooterSection from "./footer"

const Footer = (props) => {
	return (
        <>
            <FooterSection />
        </>
	)
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
